import React from 'react';
import styled from 'styled-components';
import { Trans } from '@lingui/macro';
import { fontSize, palette, Text, lineHeight, spacing } from '@landr/maestro';

export const Wrapper = styled(Text)`
    font-size: ${fontSize('md')};
    color: ${palette('neutral.300')};
    line-height: ${lineHeight('md')};
    margin-top: ${spacing('xxl')};
    margin-bottom: 0;
`;

const OneCreditOneSample = () => (
    <Wrapper>
        <Trans>1 CREDIT = 1 ROYALTY-FREE SAMPLE</Trans>
    </Wrapper>
);

export default OneCreditOneSample;
